let data3 =
[
    {
    id : 1,  
    title: "24X7 Free Support",
    contents:"Passage Of Lorem Ipsum, You Need To Be Amet Embarrassing.",
    imgUrl: "img/information1.jpg"
    },
    {
    id : 2,  
    title: "Free Worldwide Shipping",
    contents:"Passage Of Lorem Ipsum, You Need To Be Amet Embarrassing.",
    imgUrl: "img/information2.jpg"
    },
    {
    id : 3,  
    title: "Money Back Guarantee",
    contents:"Passage Of Lorem Ipsum, You Need To Be Amet Embarrassing.",
    imgUrl: "img/information3.jpg"
    },
    {
    id : 4,  
    title: "Win $100 To Shop",
    contents:"Passage Of Lorem Ipsum, You Need To Be Amet Embarrassing.",
    imgUrl: "img/information4.jpg"
    }
]


    export default data3;